import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Project } from 'src/app/interfaces/project';
import { Target } from 'src/app/interfaces/target';
import { ProjectService } from 'src/app/services/project.service';
import { TargetPickerService } from '../../services/target-picker.service';
import { DistancePipe } from '../../pipes/distance.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../loader/loader.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ImgFallBackDirective } from '../../directives/img-fallback.directive';
import { NgIf } from '@angular/common';
import { IonRippleEffect } from '@ionic/angular/standalone';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AnalyticsType } from 'src/app/enums/analytics-type';
import { DivClickDirective } from 'src/app/directives/div-click.directive';

@Component({
  selector: 'app-search-item',
  templateUrl: './search-item.component.html',
  standalone: true,
  imports: [
    NgIf,
    ImgFallBackDirective,
    NgxSkeletonLoaderModule,
    InlineSVGModule,
    LoaderComponent,
    TranslateModule,
    DistancePipe,
    IonRippleEffect,
    DivClickDirective,
  ],
})
export class SearchItemComponent implements OnInit {
  project: Project;
  @Input('project') set itemSetter(project: Project) {
    this.project = project;

    if (project.childrenProjects) {
      this.projectService.starChanged$.subscribe((p: Project) => {
        if (
          this.project.childrenProjects.find((cp) => cp.id === p.id) &&
          p.starred &&
          !this.project.starred
        ) {
          this.project.starred = true;
          this.disabled = true;
        }
      });
    }
  }
  @Input() withDistance: boolean = false;
  @Input() loading: boolean = false;
  @Input() detailsBlocked: boolean = false;
  @Input() pickingTarget: boolean = false;
  targets: Target[];
  @Input() location?: string;
  @Output() removed = new EventEmitter<string>();
  @Output() waiting = new EventEmitter<void>();
  disabled: boolean = false;

  constructor(
    private projectService: ProjectService,
    private targetPickerService: TargetPickerService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.targetPickerService.starDone$.subscribe((projectId: number) => {
      if (
        projectId === this.project.id ||
        (this.project.childrenProjects &&
          this.project.childrenProjects.find((cp) => cp.id === projectId))
      ) {
        this.disabled = false;
      }
    });
  }

  openProject() {
    if (this.detailsBlocked) {
      return;
    }
    this.router.navigate(['projects', this.project.slug]);
  }

  async toggleFollowProject(event) {
    event.stopPropagation();
    this.disabled = true;
    if (this.project.starred) {
      this.projectService.unstarProject(this.project);
      this.analyticsService.logEvent(
        AnalyticsType.PROJECT_UNFOLLOW,
        {},
        this.project
      );
      this.removed.next(this.project.slug);
      this.disabled = false;
    } else {
      this.waiting.next();
      this.targetPickerService.presentTargets(this.project);
    }
  }
}
